// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#dashboard-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 70px;
}

#dashboard-header__welcome {
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 5px;
  }

#dashboard-header__greeting-msg {
    font-size: 18px;
    color: #475467;
    font-weight: 100;
    margin-bottom: 5px;
  }

#dashboard-header__right {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

#dashboard-section1 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 12px;
  gap: 12px;
  margin-bottom: 20px;
  width: 100%;
  min-height: 300px;
  max-height: 400px;
}

#dashboard-section1__left {
    grid-column: 1 / 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

#dashboard-section1__right {
    grid-column: 2 / 3;
    display: grid;
    grid-template-rows: 2fr 3fr;
    grid-gap: 12px;
    gap: 12px;
  }

#dashboard-section1__right__top {
      grid-row: 1 / 2;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-weight: 100;
    }

#dashboard-section1__right__bottom {
      grid-row: 2 / 3;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
#dashboard-section2 {
  min-height: 250px;
  width: 100%;
  margin-bottom: 20px
}
#dashboard-section2 > div {
    min-height: 250px;
  }
#dashboard-section3 {
  width: 100%;
  margin-bottom: 20px;
}

#dashboard__ad-impressions--value {
  font-size: clamp(1.8rem, 2.8vw, 3rem);
  font-weight: 400;
  color: #475467;
  padding-right: 5px;
}
#dashboard__ad-impressions--percent {
  display: flex;
  flex-wrap: nowrap;
  font-size: 20px;
  align-items: center;
  height: 100%;
}
/* Top Recipes for creators */
#dashboard__top-recipe {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
}
#dashboard__top-recipe-link {
    width: 60%;
  }
#dashboard__top-recipe-link-inside {
    /* display: flex;
    flex-wrap: nowrap; */
    align-items: center;
    font-size: clamp(0.8rem, 1.1vw, 1.5rem);
  }
#dashboard__top-recipe-name {
    color: #475467;
    /* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 5px;
  }
#dashboard__top-recipe-revenue {
    display: flex;
    flex-wrap: nowrap;
    font-size: 20px;
    align-items: center;
    height: 100%;
    font-size: clamp(1rem, 1.1vw, 1.5rem);
  }

@media only screen and (min-width: 1440px) {
  #dashboard__ad-impressions--value {
    font-size: clamp(1.5rem, 2.5vw, 4rem);
  }
  #dashboard__ad-impressions--percent {
    font-size: 22px;
  }
}
@media (min-width: 1100px) {
  #dashboard__ad-impressions--value {
    position: relative;
    top: -8px;
  }
}
@media (min-width: 1800px) {
  #dashboard-section2 {
    min-height: 300px
  }
    #dashboard-section2 > div {
      min-height: 300px;
    }
}
@media (min-width: 2900px) {
  #dashboard-section2 {
    min-height: 310px
  }
    #dashboard-section2 > div {
      min-height: 310px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.pcss"],"names":[],"mappings":"AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAiBlB;;AAhBE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;AACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;AACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;AAGF;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAa;EAAb,SAAa;EACb,mBAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AA6BnB;;AA5BE;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;AACA;IACE,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,cAAa;IAAb,SAAa;EAgBf;;AAfE;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;MACnB,gBAAgB;IAClB;;AACA;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;IACrB;AAGJ;EACE,iBAAiB;EACjB,WAAW;EACX;AAKF;AAHE;IACE,iBAAiB;EACnB;AAEF;EACE,WAAW;EACX,mBAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AAyBb;AAxBE;IACE,UAAU;EACZ;AACA;IACE;wBACoB;IACpB,mBAAmB;IACnB,uCAAuC;EACzC;AACA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;AACA;IACE,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;EACvC;;AAGF;EACE;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;AACA;EACE;IACE;EAIF;IAHE;MACE,iBAAiB;IACnB;AAEJ;AACA;EACE;IACE;EAIF;IAHE;MACE,iBAAiB;IACnB;AAEJ","sourcesContent":["$verticalGap: 20px;\n$mediascreen: 990px;\n$horizontalGap: 15px;\n$gridGap: 12px;\n\n#dashboard {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n#dashboard-header {\n  margin-bottom: $verticalGap;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  min-height: 70px;\n  &__welcome {\n    font-size: 30px;\n    font-weight: 400;\n    margin-bottom: 5px;\n  }\n  &__greeting-msg {\n    font-size: 18px;\n    color: #475467;\n    font-weight: 100;\n    margin-bottom: 5px;\n  }\n  &__right {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n\n#dashboard-section1 {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: $gridGap;\n  margin-bottom: $verticalGap;\n  width: 100%;\n  min-height: 300px;\n  max-height: 400px;\n  &__left {\n    grid-column: 1 / 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n  }\n  &__right {\n    grid-column: 2 / 3;\n    display: grid;\n    grid-template-rows: 2fr 3fr;\n    gap: $gridGap;\n    &__top {\n      grid-row: 1 / 2;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      font-weight: 100;\n    }\n    &__bottom {\n      grid-row: 2 / 3;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n}\n#dashboard-section2 {\n  min-height: 250px;\n  width: 100%;\n  margin-bottom: $verticalGap;\n\n  & > div {\n    min-height: 250px;\n  }\n}\n#dashboard-section3 {\n  width: 100%;\n  margin-bottom: $verticalGap;\n}\n\n#dashboard__ad-impressions--value {\n  font-size: clamp(1.8rem, 2.8vw, 3rem);\n  font-weight: 400;\n  color: #475467;\n  padding-right: 5px;\n}\n#dashboard__ad-impressions--percent {\n  display: flex;\n  flex-wrap: nowrap;\n  font-size: 20px;\n  align-items: center;\n  height: 100%;\n}\n/* Top Recipes for creators */\n#dashboard__top-recipe {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  width: 100%;\n  &-link {\n    width: 60%;\n  }\n  &-link-inside {\n    /* display: flex;\n    flex-wrap: nowrap; */\n    align-items: center;\n    font-size: clamp(0.8rem, 1.1vw, 1.5rem);\n  }\n  &-name {\n    color: #475467;\n    /* white-space: nowrap; */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-right: 5px;\n  }\n  &-revenue {\n    display: flex;\n    flex-wrap: nowrap;\n    font-size: 20px;\n    align-items: center;\n    height: 100%;\n    font-size: clamp(1rem, 1.1vw, 1.5rem);\n  }\n}\n\n@media only screen and (min-width: 1440px) {\n  #dashboard__ad-impressions--value {\n    font-size: clamp(1.5rem, 2.5vw, 4rem);\n  }\n  #dashboard__ad-impressions--percent {\n    font-size: 22px;\n  }\n}\n@media (min-width: 1100px) {\n  #dashboard__ad-impressions--value {\n    position: relative;\n    top: -8px;\n  }\n}\n@media (min-width: 1800px) {\n  #dashboard-section2 {\n    min-height: 300px;\n    & > div {\n      min-height: 300px;\n    }\n  }\n}\n@media (min-width: 2900px) {\n  #dashboard-section2 {\n    min-height: 310px;\n    & > div {\n      min-height: 310px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
